<template lang="pug">
  v-flex.inicio-panel.panel-full-height.mt-2.border-radius-top(xs12 sm12 md8 lg8)
    h2.title-options.omnesRegular(style="text-align:center")
      | {{ title }}
      //- v-btn(@click="$router.push('/inicio')")
        img(:src="arrowBack" width="12%")
        | Atrás
    v-layout.contain-icons-insurances(row wrap)
      //- v-flex(@click="openNewWindow('https://www.interseguro.pe/educacion-segura')" md4 lg4)
        img(:src='iconEducacion' :width="imgSize")
        p Educación Segura
      //- v-flex(@click="openNewWindow('https://www.interseguro.pe/jubilacion-segura')" md4 lg4)
        img(:src='iconJubilacionSegura' :width="imgSize")
        p Jubilación Segura
      //- v-flex(@click="openNewWindow('https://www.interseguro.pe/otros-rentas/renta-particular')" md4 lg4)
        img(:src='iconRenta' :width="imgSize")
        p Renta Particular
      v-flex(@click="openNewWindow('https://www.interseguro.pe/segurodevida/universitario/', 'Seguro Universitario')" md4 lg4)
        img(:src='iconSeguroUniversitario' :width="imgSize")
        p Seguro Universitario
      v-flex(@click="openNewWindow('https://www.interseguro.pe/segurodevida/ahorrojubilacion/', 'Ahorro Seguro')" md4 lg4)
        img(:src='iconAhorroJubilacion' :width="imgSize")
        p Ahorro Jubilación
      v-flex(@click="openNewWindow('https://www.interseguro.pe/segurodevida/protecciontotal/', 'Protección Segura')" md4 lg4)
        img(:src='iconProteccionTotal' :width="imgSize")
        p Protección Segura
    v-layout.contain-icons-insurances(row wrap)
      v-flex(@click="openNewWindow('https://www.interseguro.pe/soat/', 'SOAT')" md4 lg4)
        img(:src='iconSoat' :width="imgSize")
        p Soat Electrónico
      v-flex(@click="openNewWindow('https://www.interseguro.pe/vidacash/', 'Vida con Devolución')" md4 lg4)
        img(:src='iconVidaCash' :width="imgSize")
        p Vida con Devolución
</template>

<script>
export default {
  data () {
    return {
      title: 'Más seguros',
      imgSize: '30%',
      arrowBack: require('./../assets/icons/arrow-back.svg'),
      iconEducacion: require('./../assets/icons/icon-educacion.svg'),
      iconJubilacionSegura: require('./../assets/icons/icon-jubilacion_segura.svg'),
      iconRenta: require('./../assets/icons/icon-renta.svg'),
      iconSoat: require('./../assets/icons/icon-soat.svg'),
      iconVidaCash: require('./../assets/icons/icon-vidacash.svg'),
      iconSeguroUniversitario: require('./../assets/icons/icon-su.svg'),
      iconProteccionTotal: require('./../assets/icons/icon-pt.svg'),
      iconAhorroJubilacion: require('./../assets/icons/icon-js.svg'),
      amplitude: {
        events: {
          moreInsuranceInterest: 'Más seguros de interes'
        }
      }
    }
  },
  methods: {
    openNewWindow (url, amplitude) {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.moreInsuranceInterest,
          {
            'Seguro de interés': amplitude
          }
        )
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Más seguros - Seleccionar producto',
        label: amplitude
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Más seguros - Seleccionar producto',
        CTA: amplitude
      })
      window.open(url, '_blank')
    }
  },
  mounted () {
    const self = this

    self.$root.$emit('npsInactivity', {seccion: 'Más seguros'})
  }
}
</script>

<style>
.contain-icons-insurances {
  text-align: center;
  margin-left: 4.3em;
  margin-top: 24px;
  margin-right: 8em;
}
.contain-icons-insurances .flex p { font-size: 16px; }
.contain-icons-insurances .flex img, .contain-icons-insurances .flex p {
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/MoreInsurances.vue